<template>
  <ModalBase show-modal :auto-h="!isEdit" :narrow="!isEdit" @close-modal="close" overlay-scrollb>
    <template v-slot:titlebar>
      <TitleBar variant-class="title-modal">
        <template v-slot:pretitle>
          {{ isEdit ? $gettext('EDIT') : $gettext('ADD') }}
        </template>
        <template v-slot:title>
          <div class="d-flex justify-contents-center align-items-center">
            <span>{{ isEdit ? contactDetails.name : $gettext('New contact') }}</span>
            <b-badge v-if="isYourCompany" variant="primary" class="header-badge">{{
              $gettext('Your company')
            }}</b-badge>
          </div>
        </template>
        <template v-slot:buttons>
          <div class="modal-action-bar">
            <GekkoButton
              v-if="isEdit"
              :text="$gettext('Delete contact')"
              icon="fa-solid fa-trash-can"
              class="text-danger"
              v-gk-confirm="{
                title: $gettext('Delete contact?'),
                message: $gettext('Are you sure you want to delete this contact?'),
                options: {
                  variant: 'danger',
                  confirmText: $gettext('Delete'),
                },
                callback: deleteContact,
              }"
            />
          </div>
        </template>
      </TitleBar>
    </template>
    <template v-slot:maincontent>
      <ContactFormSimple
        v-if="!loading && !isEdit"
        ref="contactformsimple"
        :contact="contactDetails"
        @created="onContactCreated"
      />

      <ContactForm
        v-if="!loading && isEdit"
        ref="contactform"
        :contactId="contactDetails.id"
        :contact="contactDetails"
        @updated="onContactUpdated"
      />
    </template>
    <template v-slot:actions>
      <GekkoButton
        @click="saveForm"
        :text="$gettext('Save Contact')"
        icon="fa-solid fa-floppy-disk"
        type="submit"
        class="float-right"
      />
    </template>
  </ModalBase>
</template>

<script>
import { mapGetters } from 'vuex'
import CustomerService from '@/store/services/customer.service'
import TitleBar from '@/components/TitleBar'
import GekkoButton from '@/components/GekkoButton'
import ModalBase from '@/components/base_components/ModalBase'
import ContactForm from '@/components/contacts/ContactForm'
import ContactFormSimple from '@/components/contacts/ContactFormSimple'

export default {
  name: 'ContactModalSimple',
  components: {
    ModalBase,
    TitleBar,
    ContactForm,
    ContactFormSimple,
    GekkoButton,
  },
  props: {
    contact: {
      type: Object,
      default: null,
    },
    newCustomer: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: true,
      contactDetails: null,
    }
  },
  computed: {
    ...mapGetters({
      currentCompany: 'main/getCurrentCompany',
      preferredLanguage: 'main/getPreferredLanguage',
      getCompanyId: 'main/getCompanyId',
    }),
    isYourCompany() {
      return this.contact && this.contact.id == this.getCompanyId
    },
    isEdit() {
      return !!this.contact
    },
  },
  created() {
    this.setupData()
  },
  methods: {
    close() {
      this.$emit('close-modal', false)
    },
    setupData() {
      if (this.contact) {
        this.contactDetails = Object.assign({}, this.contact)
      } else {
        this.contactDetails = {
          name: this.newCustomer ? this.newCustomer : '',
          contact_name: '',
          email: '',
          phone_number: '',
          kvk: '',
          btw: '',
          is_customer: true,
          is_supplier: false,
          is_archived: false,
          address: '',
          postal_code: '',
          city: '',
          country: this.currentCompany.country,
          show_country_on_invoice: false,
          description: '',
          hourly_rate: null,
          default_km_rate: null,
          default_payment_term: null,
          owner_company: this.getCompanyId,
          invoice_language: this.preferredLanguage,
        }
      }
      this.loading = false
    },
    onContactCreated(val) {
      this.$emit('created', val)
      this.close()
    },
    onContactUpdated(val) {
      this.$emit('updated', val)
      this.close()
    },
    deleteContact() {
      CustomerService.destroy(this.contact.id)
        .then(() => {
          this.$emit('deleted', this.contact.id)
          this.$store.commit('setAlert', {
            title: this.$gettext('Contact deleted'),
            text: this.$gettext('The contact was deleted correctly.'),
            variant: 'success',
            duration: 4,
          })
          this.close()
        })
        .catch((response) => {
          if (response.status === 404) {
            this.close()
          } else {
            this.$store.commit('setAlert', {
              title: this.$gettext('Error deleting contact'),
              text: this.$gettext(
                'This customer cannot be deleted, only archived. Only customers that have no invoices, quotations, costs, hours, recurrent invoices attached to them can be deleted.'
              ),
              variant: 'danger',
              duration: 4,
            })
          }
        })
    },
    saveForm() {
      if (this.isEdit) {
        this.$refs.contactform.saveForm()
      } else {
        this.$refs.contactformsimple.saveForm()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.header-badge {
  margin-right: 10px;
  margin-left: 20px;
  font-size: 14px;
}
</style>
